export const BASE_URL =
  process.env.REACT_APP_BACKEND_URL !== undefined
    ? process.env.REACT_APP_BACKEND_URL
    : 'http://localhost:8080/';
export const READ_ALL_CATEGORY = '/category/readAllCategories';
export const READ_ALL_PRODUCTS = '/store/readAllStoreInventoryType?';
export const API_OFFER = '/offer/getAllApiOffer';
export const CATEGORYOFFER = '/offer/readAllOfferType?';
export const READ_ALL_BANNER_OFFERS = '/offer/getAllBannerFilter';
export const ADD_TO_CART = '/cart/createAddToCart';
export const REMOVE_FROM_CART = '/cart/removeCartItem';
export const READ_CART_ITEMS = '/cart/readOneOrdersQuntity?';
export const VALIDATE_PROMOCODE = '/cart/validatePromocode';
export const CONTACT_ADD = '/contact/createContact';
export const VERIFY_EMAIL = '/users/forgetPassword';
export const GET_ORDER_BY_ID = `/order/readOneOrderData`;
export const VERIFY_OTP = '/users/readOneuserOtp';
export const UPDATE_PASSWORD = '/users/updatePassword';
export const CREATE_ORDER = '/order/createOrder';
export const READ_ONE_USER = '/users/readOneUser?';
export const READ_ONE_EVENT = '/event/readOneEvents?event_id=';
export const READ_ALL_EVENTS = '/event/readAllEvents';
export const READ_ALL_ORDERS = '/order/readAllOrder?';
export const READ_ITEMS_FROM_CART = '/order/readOneOrderData?';
export const READ_ALL_OFFER = '/offer/getAllApiOffer';
export const READ_ALL_FAQ = '/faq/readAllFaqs';
export const READ_EVENT_THEME = '/websiteColorThemes/readOneEventColorThemes';
export const READ_DEFAULT_THEME = '/websiteColorThemes/readOneDefaultColorThemes';
export const READ_EVENT_HOWITWORKS = '/howItWork/eventIdHowItWork';
export const READ_HOWITWORKS = '/howItWork/readAllHowItWorks';
export const UPDATE_USER = '/users/updateUserEmail';
export const UPDATE_USER_WITH_USER_ROLE = '/users/updateUserEmailWithUserRole';
export const READ_ALL_NOTIFICATION = '/notification/readAllEventNotification';
export const READ_NESTED_CATEGORIES = '/category/readAllCategoriesData';
export const UPDATE_NOTIFICATION = '/notification/updateIsReadNotification';
export const CREATE_INTERESTED = '/interested/createInterested';
export const READ_ALL_INTERESTED = '/Interested/readAllInterested';
export const DOWNLOAD_QR_CODE = '/order/downloadQrCode';
export const RESEND_LINK = '/users/resendLinkVerification';
export const CATEGORIES_PARENTDATA = '/category/readCategoriesAllParent';
export const CALCULATE_GUEST_CART = '/cart/calculateGuestCart';
